import auctionUser from "./auctionUser";
import bidSubscriptionResponse from "./bidSubscriptionResponse";
import liveAuctionCode from "./liveAuctionCode";

export const auctionReducers = { auctionUser, bidSubscriptionResponse, liveAuctionCode };